import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtmParams, syncCampaignAttributionConsent } from "../utils/utmTracking";

// Layout capture runs before passive auth/profile effects on every public route.
export function useCampaignAttribution() {
  const { pathname, search } = useLocation();
  useLayoutEffect(() => {
    captureUtmParams(search);
  }, [pathname, search]);
  useLayoutEffect(() => {
    window.addEventListener("22n:consent-change", syncCampaignAttributionConsent);
    return () => window.removeEventListener("22n:consent-change", syncCampaignAttributionConsent);
  }, []);
}
